import NoMatchPage from "pages/404";
import LandingLayout from "layouts/LandingLayout";
import { MyHorses } from "pages/MyHorses";
import InsideLayout from "layouts/InsideLayout";
import LandingPage from "pages/LandingPage";
import { TermsAndCondition } from "pages/TermsAndPolicy/TermsAndCondition";
import { PrivacyPolicy } from "pages/TermsAndPolicy/PrivacyPolicy";
import { ProtectedGuard } from "guards/LoggedInGuard";
import { BuySaddles } from "pages/BuySaddles";
import { SaddleDetails } from "pages/SaddleDetails";
import Favorite from "pages/Favorite";
import CartPage from "pages/CartPage";
import Event from "pages/EventPage";
import Profile from "pages/Profile";
import MyOrders from "pages/MyOrders";
import MyBookings from "pages/MyBookings";
import OrderDetail from "pages/OrderDetail";
import RegisterModal from "../components/Modal/Auth/RegisterModal";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useEffect } from "react";
import Cactus from "pages/BuySaddles/Cactus";
import { useAuthStore, useLoggedIn } from "../stores/auth/authStore";
import RemoveTrailingSlash from "utils/removeTrailingSlash";
import PartnerPage from "pages/PartnerPage";
import BillyCook from "pages/BuySaddles/BillyCook";
import { Modal, useModalStore } from "stores/modal/useModalStore";
import CustomSaddleTreePage from "pages/CustomSaddleTree";
import { SiteMap } from "pages/SiteMap";
import { getManufacturerRequestedSubdomain } from "utils/subdomainFromHostname";

const AppRoutes = () => {
  const { user } = useLoggedIn();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location?.state || {};
  const open = useModalStore((s) => s.open);
  const subdomain = useAuthStore((state) => state.domain);
  const domainResolved = useAuthStore((state) => state.domainResolved);
  const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";

  const requestedSub = getManufacturerRequestedSubdomain(hostname);
  const isLandingSub = !requestedSub;

  useEffect(() => {
    if (location.pathname === "/signup" && !user) {
      open(Modal.Register);
    } else if (user && location.pathname === "/signup") {
      navigate("/");
    }
  }, [location, user, navigate, open]);

  useEffect(() => {
    useAuthStore.getState().fetchFullUserProfile();
  }, []);

  if (!domainResolved) return null;

  if (requestedSub && !isLandingSub && !subdomain) {
    return (
      <Routes location={state?.backgroundLocation || location}>
        <Route path="*" element={<NoMatchPage />} />
      </Routes>
    );
  }

  return (
    <Routes location={state?.backgroundLocation || location}>
      <Route
        element={!isLandingSub && requestedSub ? <InsideLayout /> : <LandingLayout />}
      >
        <Route index element={!isLandingSub && requestedSub ? <BuySaddles /> : <LandingPage />} />
        <Route
          path="/signup"
          element={
            requestedSub && !isLandingSub ? (
              <>
                <BuySaddles />
                <RegisterModal />
              </>
            ) : (
              <>
                <LandingPage />
                <RegisterModal />
              </>
            )
          }
        />
        <Route path="custom-saddle-tree" element={<CustomSaddleTreePage />} />
      </Route>

      <Route
        element={
          <ProtectedGuard>
            <InsideLayout />
          </ProtectedGuard>
        }
      >
        {/* Protected routes */}
        <Route path="user">
          <Route
            path="horses"
            element={
              <MyHorses />
            }
          />
        </Route>
        <Route
          path="profile"
          element={<Profile />}
        />
        <Route path="cart" element={<CartPage />} />
        <Route path="my-orders" element={<MyOrders />} />
        <Route path="my-bookings" element={<MyBookings />} />
        <Route path="order/:orderId" element={<OrderDetail />} />
      </Route>

      {/* Non-protected routes */}
      <Route
        element={<InsideLayout />}
      >
        <Route
          path="buy"
          element={<BuySaddles />}
        />
        <Route
          path="event"
          element={
            <Event />
          }
        />
        <Route
          path="saddle/:title"
          element={
            <SaddleDetails />
          }
        />
        <Route path="terms-and-conditions" element={<TermsAndCondition />} />
        <Route path="partner" element={<PartnerPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="sitemap" element={<SiteMap />} />

        {!subdomain && (
          <>
            <Route path="cactus" element={<Cactus />} />
            <Route path="billy-cook" element={<BillyCook />} />
          </>
        )}
        <Route
          path="favorite"
          element={
            <Favorite />
          }
        />
      </Route>

      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};

const AppWrapper = () => (
  <Router>
    <RemoveTrailingSlash />
    <AppRoutes />
  </Router>
);

export default AppWrapper;
